'use strict';

/**
 * Simple autofocus directive that focuses an element when it appears
 * Works reliably regardless of timing issues
 */
angular.module('posApp').directive('autoFocus', ($timeout) => ({
  restrict: 'A',

  link: function (scope, elm) {
    // Use $timeout to ensure DOM is ready and digest cycle is complete
    $timeout(() => {
      elm[0].focus();
    }, 0);
  },
}));
